import React from 'react';
import Link from '@material-ui/core/Link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretSquareLeft } from '@fortawesome/free-regular-svg-icons';

export default function BackLink({ href }: { href: string }) {
  return (
    <Link variant="body1" href={href} aria-label="Back">
      <FontAwesomeIcon icon={faCaretSquareLeft} />
      &nbsp;Back
    </Link>
  );
}
